import { Stack, styled } from "@mui/material";

export const MFIUserWrapper = styled(Stack)(() => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .mfi-user-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    },
                    "& .MuiTableCell-root:last-child": {
                        width: "25%",
                    }
                }
            },
        },
    }
})